import React, { useLayoutEffect, useRef, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const OccupancyRateChart = ({ data }) => {
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const [hasData, setHasData] = useState(true);


  useLayoutEffect(() => {
    // Ensure data exists before creating the chart
    if (!data || data.length === 0) {
      setHasData(false);
      return;
    }
    setHasData(true);
    let chart = am4core.create(containerRef.current, am4charts.PieChart3D);

    chart.logo.disabled = true;// Disable the amCharts watermark

    chart.innerRadius = am4core.percent(40); // Makes it a donut

    const total = data?.reduce((sum, item) => sum + parseFloat(item.value || 0), 0);
    
    const totalOccupied = data?.find(item => item.category === 'Occupied')?.value || 0;

    const totalVacant = data?.find(item => item.category === 'Vacant')?.value || 0;

    const occupiedPercentage = total > 0 ? ((totalOccupied / total) * 100).toFixed(2) : "0.00";
    const vacantPercentage = total > 0 ? ((totalVacant / total) * 100).toFixed(2) : "0.00";

    const chartData = data?.map(item => {
      if (item.category === "Occupied") {
        item.value = parseFloat(occupiedPercentage);
      }
      if (item.category === "Vacant") {
        item.value = parseFloat(vacantPercentage);
      }
      return item;
    });

    chart.data = chartData || [];

    let centerLabel = chart.seriesContainer.createChild(am4core.Label);

    centerLabel.horizontalCenter = "middle";
    centerLabel.verticalCenter = "middle";
    centerLabel.fontSize = getFontSize();
    centerLabel.fill = am4core.color("#404040E5"); // text color
    centerLabel.textAlign = "middle";
    centerLabel.fontWeight = "bold";

    centerLabel.text = `${Math.round(total)}`;

    let series = chart.series.push(new am4charts.PieSeries3D());

    series.dataFields.value = "value";
    series.dataFields.category = "category";
    series.dataFields.color = "color";

    series.colors.step = 1; // Disable default color stepping

    series.labels.template.fill = am4core.color("#333"); // set all label text to dark gray (or whatever you want)
    series.labels.template.fill = am4core.color("#00000099");
    series.labels.template.fontSize = 14;
    series.labels.template.fontWeight = "bold";

    series.labels.template.adapter.add("text", (text, target) => {
      const dataItem = target.dataItem?.dataContext;
      if (dataItem) {
        return `${dataItem.category}\n[#${dataItem.color}]${dataItem.value}%`;
      }
      return text;
    });

    series.ticks.template.strokeWidth = 1.5;
    series.ticks.template.strokeOpacity = 1;

    // Distance from donut
    series.labels.template.radius = am4core.percent(-10); // increase to push label out
    // series.labels.template.relativeRotation = 1; // keep labels flat

    series.slices.template.propertyFields.fill = "color"; // slice color
    series.ticks.template.propertyFields.stroke = "color"; // tick line matches slice color

    chartRef.current = chart;

    return () => {
      chart.dispose();
    };
  }, [data]);
  
  const getFontSize = () => {
    const width = window.innerWidth;

    if (width < 456) {
      return 16;
    } else if (width < 768) {
      return 30;
    } else {
      return 30; 
    }
  };

  return (
    <div>
      {hasData ? (
    <div
      // id="chartdiv"
      ref={containerRef}
      className="w-full [@media(min-width:456px)]:h-auto  [@media(min-width:456px)]:min-h-[300px]   sm:h-auto sm:min-h-[300px] p-0 m-0  z-50 sm:min-w-[380px]"
      // style={{ width: "100%", height: "300px" }}
      style={{ width: "100%", height: "150px",
       // minHeight: "300px",
        "@media(min-width:465px)": {
          height: "300px",
         // minHeight: "300px",
        },
      }}
    />
      ) : (
        <div className="text-center text-gray-400 relative top-0 left-[-100px] text-base py-12">
          No data available
        </div>
      )}
    </div>
  );
};

export default OccupancyRateChart;
